import { SimpleXHREndpoint } from './constants';
export var getFakeResponse = function (endpoint) { return function (options) {
    if (process.env.NODE_ENV !== 'production') {
        switch (endpoint) {
            case SimpleXHREndpoint.GIVE_POINTS_POPUP: {
                var response = {
                    pointsBalance: 10,
                };
                return response;
            }
            case SimpleXHREndpoint.GIVE_LLAMA: {
                var response = {}; // BE is returning redundant session
                return response;
            }
            case SimpleXHREndpoint.GIVE_POINTS: {
                var response = {
                    success: true,
                };
                return response;
            }
            default:
                return;
        }
    }
}; };
//# sourceMappingURL=fakeResponses.js.map